import { Action, createReducer, on } from '@ngrx/store';
import * as AuthActions from './auth.actions';
import { AuthState, AUTH_INIT_STATE } from './auth.state';

const _authReducer = createReducer(

    AUTH_INIT_STATE,

    on(
        AuthActions.authenticatedAction,
        (state, action) => ({
            ...state,
            userID: action.userData.uid,
            userData: action.userData,
            isAuthenticated: true,
            isFetching: false,
            error: null,
        })
    ),

    on(
        AuthActions.logoutAction,
        (state, action) => ({
            ...state
        })
    ),

    on(
        AuthActions.notAuthenticatedAction,
        (state, action) => {
            action.isAuthenticatedPreviously = state.isAuthenticated;
            
            return {
                ...AUTH_INIT_STATE,
            }
        }
    ),

    on(
        AuthActions.loginAsGuestAction,
        AuthActions.loginWithFacebookAction,
        AuthActions.loginWithGoogleAction,
        AuthActions.loginWithAppleAction,
        AuthActions.loginWithWalletAction,
        AuthActions.signupAction,
        AuthActions.resetPasswordAction,
        AuthActions.loginSuccessAction,
        AuthActions.signupSuccessAction,
        (state, action) => ({
            ...state,
            error: null,
            isFetching: true,
        })
    ),

    on(
        AuthActions.loginWithEmailAction,
        (state, action) => ({
            ...state,
            error: null,
            isFetching: true,
            hasWeakPassword: action.hasWeakPassword,
        })
    ),

    on(
        AuthActions.resetPasswordSuccessAction,
        (state, action) => ({
            ...state,
            error: null,
            isFetching: false,
        })
    ),

    on(
        AuthActions.authErrorAction,
        AuthActions.resetPasswordFailedAction,
        AuthActions.signupErrorAction,
        AuthActions.loginFailedAction,
        (state, action) => ({
            ...state,
            isFetching: false,
            isAuthenticated: false,
            error: action.error
        })
    ),

    on(
        AuthActions.nonAnonymousLogin,
        (state, action) => ({
            ...state,
            userData: {
                ...state.userData,
                isAnonymous: false,
            }
        })
    ),

    on(
        AuthActions.setWeakPasswordAction,
        (state, action) => ({
            ...state,
            hasWeakPassword: action.isWeak,
        })
    ),

    on(
        AuthActions.setIsRegistrationAction,
        (state, action) => ({
            ...state,
            isRegistration: action.isRegistration,
        })
    ),
)

export function authReducer(state: AuthState, action: Action) {
    return _authReducer(state, action);
}
